import { render, staticRenderFns } from "./server-error.vue?vue&type=template&id=7f1a16b0&"
import script from "./server-error.vue?vue&type=script&lang=ts&"
export * from "./server-error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports